import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HelpPage from '../HelpPage';

const HelpPageRoute: React.FC = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };

  if (!open) return null;
  return <HelpPage onClose={handleClose} />;
};

export default HelpPageRoute;
